<template>
  <div id="lunchBoxes">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h2 class="section-title">Lunch Boxes</h2>
          <div class="row">
            <div class="col-md-6" v-for="box in lunchBoxes">
              <div class="lunch-box">
                <div v-if="!box.available_now" class="badge alert-danger">Not available now</div>
                <h3>{{ box.title }}</h3>
                <p class="description text-muted">{{ box.description }}</p>

                <div class="items">
                  <div class="item-group" v-for="category in box.categories">
                    <h5>{{ category.title }} <span class="text-muted">(max. {{ category.max_products}})</span></h5>
                    <div class="products">
                      <div :class="['product', productIsSelected(box, category, product) ? 'selected' : '']"
                           v-for="product in category.products" @click="addToBox(box, category, product)"
                      >
                        {{ product.title }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12 note">
                    <h5>Note</h5>
                    <div class="form-group">
                      <label>Leave a note...</label>
                      <textarea class="form-control" placeholder="Leave a note..." rows="3" v-model="box.note" v-on:keyup="noteChanged(box)"></textarea>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="text-center change-quantity">
                      <span class="plus" @click="plusQuantity(box)">+</span>
                      <span class="quantity">{{ box.quantity }}</span>
                      <span class="minus" @click="minusQuantity(box)">-</span>
                    </div>
                  </div>
                </div>

                <br>

                <div class="row">
                  <div class="col-md-6">
                    <b-button class="btn-danger" :disabled="!box.available_now" @click="addToCart(box)">
                      Add to cart
                    </b-button>
                  </div>

                  <div class="col-md-6">
                    <div class="offer-price">
                      <span v-if="!box.discount" class="no-discount">£ {{ box.price.toFixed(2) }}</span>
                      <span class="has-discount" v-else>
                        <span class="price">£ {{ box.price.toFixed(2) }}</span>
                        <span class="discount">£ {{ box.discount.toFixed(2) }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12" v-if="!lunchBoxes.length">
              <p>There are no available Lunch Box Offers at the moment.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'

  export default {
    name: 'homepage',
    computed: {
      ...mapState({
        user: state => state.user,
        location: state => state.location,
        cart: state => state.cart
      })
    },
    data () {
      return {
        lunchBoxes: [],
        selectedBox: []
      }
    },
    created () {
      if (this.location) {
        this.$store.dispatch('ListLunchBoxes', this.location.id)
          .then(response => {
            this.lunchBoxes = response.offers

            for (let i = 0; i < this.lunchBoxes.length; i++) {
              this.lunchBoxes[i].quantity = 1
            }
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    methods: {
      plusQuantity (box) {
        this.lunchBoxes = this.lunchBoxes.map((lunchBox) => {
          if (lunchBox.id === box.id) {
            lunchBox.quantity++
          }

          return lunchBox
        })

        this.selectedBox = this.selectedBox.map((selBox) => {
          if (selBox.box_id === box.id) {
            selBox.quantity++
          }

          return selBox
        })
      },
      minusQuantity (box) {
        this.lunchBoxes = this.lunchBoxes.map((lunchBox) => {
          if (lunchBox.id === box.id) {
            lunchBox.quantity = lunchBox.quantity > 1 ? lunchBox.quantity - 1 : 1
          }

          return lunchBox
        })

        this.selectedBox = this.selectedBox.map((selBox) => {
          if (selBox.box_id === box.id) {
            selBox.quantity = selBox.quantity > 1 ? selBox.quantity - 1 : 1
          }

          return selBox
        })
      },
      addToBox (box, category, product) {
        let selectedBox = this.selectedBox.filter((selBox) => {
          return selBox.box_id === box.id
        })

        let isBoxNew = false

        if (!selectedBox.length) {
          selectedBox = {
            box_id: box.id,
            box_title: box.title,
            box_code: box.code,
            box_price: box.price,
            box_discount: box.discount,
            note: typeof box.note !== 'undefined' ? box.note : null,
            quantity: box.quantity,
            categories: []
          }

          isBoxNew = true
        } else {
          selectedBox = selectedBox[0]
        }

        let boxCategory = selectedBox.categories.filter((boxCategory) => {
          return boxCategory.category_id === category.id
        })

        let isBoxCategoryNew = false

        if (!boxCategory.length) {
          boxCategory = {
            category_id: category.id,
            category_title: category.title,
            max_products: category.max_products,
            products: []
          }

          isBoxCategoryNew = true
        } else {
          boxCategory = boxCategory[0]
        }

        let boxProduct = boxCategory.products.filter((boxProduct) => {
          return boxProduct.id === product.id
        })

        if (boxProduct.length) {
          boxCategory.products = boxCategory.products.filter((boxProduct) => {
            return boxProduct.id !== product.id
          })
        } else if (boxCategory.products.length === boxCategory.max_products) {
          this.notifyVue('danger', 'You can add maximum ' + boxCategory.max_products + ' products from this category.')
        } else {
          boxCategory.products.push(product)
        }

        if (boxCategory.products.length === 0) {
          selectedBox.categories = selectedBox.categories.filter((thisBoxCategory) => {
            return thisBoxCategory.category_id !== category.id
          })
        } else if (!isBoxCategoryNew) {
          selectedBox.categories = selectedBox.categories.map((thisBoxCategory) => {
            return thisBoxCategory.category_id === category.id ? boxCategory : thisBoxCategory
          })
        } else {
          selectedBox.categories.push(boxCategory)
        }

        if (selectedBox.categories.length === 0) {
          this.selectedBox = this.selectedBox.filter((selBox) => {
            return selBox.box_id !== box.id
          })
        } else if (!isBoxNew) {
          this.selectedBox = this.selectedBox.map((selBox) => {
            return selBox.box_id === box.id ? selectedBox : selBox
          })
        } else {
          this.selectedBox.push(selectedBox)
        }
      },
      productIsSelected: function (box, category, product) {
        let selectedBox = this.selectedBox.filter((selBox) => {
          return selBox.box_id === box.id
        })

        if (selectedBox.length) {
          selectedBox = selectedBox[0]
          let boxCategory = selectedBox.categories.filter((boxCategory) => {
            return boxCategory.category_id === category.id
          })

          if (boxCategory.length) {
            boxCategory = boxCategory[0]
            let boxProduct = boxCategory.products.filter((boxProduct) => {
              return boxProduct.id === product.id
            })

            return boxProduct.length
          }
        }

        return false
      },
      noteChanged (box) {
        let selectedBox = this.selectedBox.filter((selBox) => {
          return selBox.box_id === box.id
        })

        if (selectedBox.length) {
          selectedBox = selectedBox[0]

          selectedBox.note = box.note
        }
      },
      addToCart (box) {
        let selectedBox = this.selectedBox.filter((selBox) => {
          return selBox.box_id === box.id
        })

        if (selectedBox.length) {
          selectedBox = selectedBox[0]

          if (Object.keys(box.categories).length !== selectedBox.categories.length) {
            this.notifyVue('danger', 'Please select from the all available categories.')

            return false
          }

          this.cart.push({
            type: 'offer',
            offer_id: selectedBox.box_id,
            title: selectedBox.box_title,
            code: selectedBox.box_code,
            image: null,
            price: selectedBox.box_price,
            discount: selectedBox.box_discount,
            note: selectedBox.note,
            quantity: selectedBox.quantity,
            items: selectedBox.categories
          })

          this.selectedBox = this.selectedBox.filter((selBox) => {
            return selBox.box_id !== box.id
          })

          this.lunchBoxes = this.lunchBoxes.map((lunchBox) => {
            if (lunchBox.id === box.id) {
              lunchBox.quantity = 1
              lunchBox.note = null
            }

            return lunchBox
          })

          this.$store.dispatch('UpdateCart', this.cart)
          this.notifyVue('success', `Lunch Box ${selectedBox.box_title} has been added to your cart.`)
        } else {
          this.notifyVue('danger', 'You should select products for this lunch box.')
        }
      },
      notifyVue (type, message) {
        this.$notifications.notify({
          message: message,
          icon: '',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: type
        })
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// lunch-boxes.vue?0751db16